export { LoadingComponent } from './lib/components/loading/loading.component';
